import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
  inject,
} from '@angular/core';

@Directive({ selector: '[appFocusLost]' })
export class FocusLostDirective {
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  @Output('appFocusLost') public focusLost = new EventEmitter<void>();
  private hasFocus = false;

  @HostListener('document:click', ['$event.target'])
  public onClick(target: HTMLElement): void {
    if (this.elementRef.nativeElement.contains(target)) {
      return;
    }
    this.fireEventIfFocusLost();
  }

  @HostListener('document:keydown.escape')
  public onEscapeKeydown(): void {
    this.fireEventIfFocusLost();
  }

  @HostListener('focusin')
  public onFocusIn(): void {
    this.hasFocus = true;
  }

  private fireEventIfFocusLost(): void {
    if (!this.hasFocus) {
      return;
    }

    this.hasFocus = false;
    this.focusLost.emit();
  }
}
